module.exports = __webpack_public_path__ + "img/landing-headphones.2635fccd.png";